var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5923 9.9996L7.6423 12.9496C7.48709 13.1057 7.39998 13.3169 7.39998 13.5371C7.39998 13.7572 7.48709 13.9685 7.6423 14.1246C7.71977 14.2027 7.81194 14.2647 7.91349 14.307C8.01504 14.3493 8.12396 14.3711 8.23397 14.3711C8.34398 14.3711 8.4529 14.3493 8.55445 14.307C8.656 14.2647 8.74817 14.2027 8.82564 14.1246L12.359 10.5913C12.4371 10.5138 12.4991 10.4216 12.5414 10.3201C12.5837 10.2185 12.6055 10.1096 12.6055 9.9996C12.6055 9.88959 12.5837 9.78066 12.5414 9.67911C12.4991 9.57757 12.4371 9.4854 12.359 9.40793L8.82564 5.83293C8.74777 5.75569 8.65542 5.69459 8.55389 5.65312C8.45236 5.61165 8.34364 5.59063 8.23397 5.59126C8.1243 5.59063 8.01558 5.61165 7.91405 5.65312C7.81252 5.69459 7.72017 5.75569 7.6423 5.83293C7.48709 5.98906 7.39998 6.20027 7.39998 6.42043C7.39998 6.64058 7.48709 6.85179 7.6423 7.00793L10.5923 9.9996Z",
    fill: "#44465F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.86d684200e3faf36aaf37eb2a4f8ce5e.svg";
export { ForwardRef as ReactComponent };